<template>
  <div>
    <!-- Main -->
    <div class="d-md-flex h-md-100 align-items-center">
      <div class="col-md-7 p-0 bg-indigo h-md-100 logoarea">
        <div
          class="text-white d-md-flex align-items-center h-100 p-5 text-center justify-content-center"
        >
          <div class="pt-5 pb-5"></div>
        </div>
      </div>
      <div class="col-md-5 p-0 bg-white h-md-100 loginarea">
        <div class="d-md-flex col-12 align-top">
          <img src="@/resources/img/ktb-logo.png" width="152" height="56" style="padding-top: 10px;">
          <img src="@/resources/img/h_elg.jpg" width="284" height="58">
          <router-link to="Login">
            <img src="@/resources/img/login.jpg" width="59" height="58">
          </router-link>
        </div>

        <div class="align-items-center h-md-100 p-5 justify-content-center">
          <span class="caution">
            ธนาคารได้รับข้อมูลการขอออกหนังสือค้ำประกัน e-LG Blockchain เรียบร้อยแล้ว
            <br>ทางหน่วยงานอำนวยสินเชื่อ (RM.) จะดำเนินการติดต่อกลับไปยังท่าน
          </span>

          

          <form @submit.prevent="saveContact" class="rounded p-5">
            <div class="title">
              <h6 class="mb-0">ข้อมูลเพื่อให้ธนาคารกรุงไทยติดต่อกลับ</h6>
            </div>
            <div class="form-group">
              <label class="have-text" for="usernameLogin">E-Mail</label>
              <input
                type="email"
                required
                v-model="email"
                name="email"
                v-validate="{required:true}"
                :class="{'input': true, 'is-danger': errors.has('email') }"
                placeholder
                class="form-control"
              >
              <span class="highlight"></span>
              <span class="bar"></span>

              <span v-show="errors.has('email')" class="help is-danger">ระบุ E-Mail</span>
            </div>
            <div class="form-group">
              <label class="have-text" for="telNo">เบอร์โทรศัพท์</label>
              <input
                type="number"
                v-model="telNo"
                name="telNo"
                v-validate="'required|digits:10'"
                :class="{'input': true, 'is-danger': errors.has('telNo') }"
                placeholder
                class="form-control"
              >
              <span v-show="errors.has('telNo')" class="help is-danger">ระบุ เบอร์โทรศัพท์ ต้องเป็นตัวเลข 10 หลัก</span>
            </div>

            <button type="submit" class="btn btn-info btn-round btn-block shadow-sm">ตกลง</button>
          </form>
        </div>
      </div>
    </div>
    <!-- End Main -->

    <footer class="ft-content space-up">
      <div class="container">
        <div class="row">
          <div class="col-6 text-left">
            <i class="feather-icon icon-phone"></i>
            <span>02-111-1111, 02-111-9999 KTB Call Center</span>
          </div>

          <div class="col-6 text-right">
            <span class="text-red">การทำรายการหลังเวลา 15.00 น. ถือว่าเป็นการทำรายการของวันทำการถัดไป</span><br>
            <i class="fa fa-copyright"></i>
            <span>สงวนสิทธิ์ พ.ศ. 2562 บมจ. ธนาคารกรุงไทย</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
import { apiClient } from "@/utils/apiClient";

export default {
  name: "saveContact",
  data() {
    return {
      email: "",
      telNo: ""
    };
  },
  methods: {
    saveContact: function() {
      var telNo = this.telNo;
      if(telNo.length !== 10){
        this.$swal("", "กรุณาระบุ เบอร์โทรศัพท์ เป็นตัวเลขให้ครบ 10 หลัก", "warning");
      }else{
        const { email, telNo } = this;

        this.$validator.validateAll().then(result => {
          this.loader = this.$loading.show();
          apiClient
            .post(
              "/api/customer/contractBack/" +
                localStorage.getItem("registerVerifyId"),
                {
                  email: this.email,
                  telNo: this.telNo
                }
            )
            .then(resp => {
              this.loader.hide();
              if (resp.data.code == "0000") {
                //success
                //alert msg บันทึกข้อมูลเรียบร้อย
                this.$swal("", "ธนาคารได้รับข้อมูลเรียบร้อย", "success");

                this.$router.push("/firstPageReg");
              }
            });
        });
      }
    }
  }
};
</script>
